import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  pcnSyncSettingFetchItemOptions: ['search'],
  pcnSyncSettingFetchItemOptionLoading: ['boolean'],
  pcnSyncSettingFetchItemOptionSuccess: ['options'],

  pcnSyncSettingShowSetting: null,
  pcnSyncSettingSaveSetting: ['formikBag', 'settings'],
  pcnSyncSettingSaveSettingSuccess: ['settings'],
  pcnSyncSettingSaveSettingLoading: ['settingIsLoading']
});

export const PcnSyncSettingTypes = Types;
export default Creators;
